import React from 'react'
import './toast.css'
export const Toast = ({ title = 'Notification' }) => {
    return (
        <div id="toast">
            <div id="img">
                <span className="material-symbols-outlined">done</span>
            </div>
            <div id="desc">{title}</div>
        </div>
    )
}

let toastTimeoutId: ReturnType<typeof setTimeout>

export enum ToastTypes {
    Success = 'success',
    Error = 'error'
}

export function launchToast(toastType: ToastTypes, title: string): void {
    const x = document.getElementById('toast')

    if (x !== null) {
        x.className = 'show'
        //@ts-ignore
        if (toastType === ToastTypes.Success) {
            x.children[0].innerHTML = `<span style="color: green !important;font-size: 35px;font-weight:900;" class="material-icons">done</span>`
        }
        if (toastType === ToastTypes.Error) {
            x.children[0].innerHTML = `<span style="color: red !important;font-size: 30px;font-weight:700;" class="material-icons">error_outline</span>`
        }
        x.children[1].textContent = title

        if (toastTimeoutId) {
            clearTimeout(toastTimeoutId)
        }

        toastTimeoutId = setTimeout(function () {
            x.className = x.className.replace('show', '')
        }, 5000)
    }
}
